'use client';

import Link from 'next/link';
import { SheetClose } from '@/components/ui/sheet';

/**
 * #4504 — "Submit your game" in the hamburger menus, directly under TV App.
 *
 * Unlike the TV App section it is always shown: it is a link to a public page, with nothing to install or
 * check first. Mounted inside both menus' sheets (`HeaderClient`, `VisitorSiteMenu`); `SheetClose` closes the
 * sheet on navigation, as the menus' own links do.
 */
export function SubmitGameMenuSection() {
  return (
    <section aria-labelledby="submit-game-menu-title" className="mt-5 border-t border-white/20 pt-4 text-white">
      <SheetClose asChild>
        <Link
          id="submit-game-menu-title"
          href="/submit-game"
          className="block rounded py-2 text-base font-semibold hover:text-cyan-200 focus-visible:outline-cyan-300"
        >
          Submit your game
        </Link>
      </SheetClose>
      <p className="pb-4 text-sm leading-relaxed text-slate-100">
        Made a browser game? Send it in to be considered for the Telegames catalog.
      </p>
    </section>
  );
}
